<template class='chat-messages' >
  <div>
    <div class="chat">
      <div class="chat-header clearfix" ref="chatHeader">

        <img :src="avatar" style="width:90px;  " class="img-preview-sm img-rounded img-circle " alt="avatar">

        <div class="chat-about">
          <div class="chat-with"><a class="widget-followers-name">{{name}}</a></div>
          <span class="label label-xs label-danger inline status" v-show="online===false">{{ $t('unavab') }}</span> 
          <span class="label label-xs label-success inline status" v-show="online"> {{ $t('online') }}</span> 
          {{status}}
        </div>
        <b-button class="pull-right" variant="danger" @click="back()"><i class="fa fa-close fa-1x "></i></b-button>
      </div> <!-- end chat-header -->
      <div class="chat-history" v-chat-scroll="{always: false, smooth: true, scrollonremoved:true}">
          
        <infinite-loading :on-infinite="infiniteChatMesages" :identifier="infiniteId" direction="top" ref="infiniteLoading">            
          <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>
          <ul class="messages" >
         <li class="messages msg"   v-for="message in $store.state.messages" >

  <div class="bubble"  v-bind:class="{ alt: message.from===$auth.user().id} ">

    <div class="txt">
      <span class="name alt mr-1" v-if="message.from===$auth.user().id">{{ $auth.user().profile.last_name }} {{ $auth.user().profile.name }} {{ $auth.user().profile.second_name }}</span>
      <span class="name mr-1" v-else>{{ message.user.name }}</span>
      <span class="timestamp ">{{ message.created | moment('timezone', $moment.tz.guess(), 'D MMMM , hh:mm:ss')}}</span>      
      <span class="message " v-html="convMessage(message.data)" v-linkified>

      </span>
      <emoji emoji="santa" :size="16" />
    </div>
    <div class="bubble-arrow"  v-bind:class="{ alt: message.from===$auth.user().id} "></div>
    <div class="bubble-avatar avatar" v-bind:class="{ alt: message.from===$auth.user().id} ">
        <img v-if="message.from===$auth.user().id" :src="ava($auth.user().profile.avatar)"/>
        <img v-else :src="ava(message.user.avatar)"/>
    </div>
  </div>
</li>
<li v-if="!$store.state.messages || $store.state.messages.length==0"><center>&bull;&bull;&bull;</center></li>
          </ul>
      </div>
    </div>
</div>
  </template>

<i18n>
{
  "en": {
    "unavab": "Offline", 
    "online": "Online",
    "back": "Back"
    
  },
  "ru": {
    "unavab": "Не в сети", 
    "online": "В сети",
    "back": "Назад"

   }
}
</i18n>

<script>
    
import VueChatScroll from 'vue-chat-scroll'
//  Import axios
import InfiniteLoading from 'vue-infinite-loading'
import textRender from '../layout/textRender.js'
import { Emoji } from 'emoji-mart-vue-fast'
import linkified from 'vue-linkify'
const api = 'chat/room'
export default {
  name: 'chat-messages',
  components: {
    InfiniteLoading,
    textRender,
    Emoji,
    VueChatScroll
  },
  directives: {
    linkified
  },
  props: ['room_id'],
  data () {
    return {
      messages: [],
      errors: [],
      busy: false,
      height: 0,
      loading: false,
      page: 1,
      infiniteId: +new Date(),
      users: [],
      avatar: [],
      name: null,
      online: false,
      status: '',
      no_ava: 'https://scispace.hb.bizmrg.com/uploads/avatars/no_avatar.png',
      no_group_ava: 'https://linksys.i.lithium.com/t5/image/serverpage/image-id/16800i3E8B46D91CD0CF26/image-size/original?v=1.0&px=-1'
    }
  },
  watch: {
    height: function (newVal, oldVal) {
      if (this.$store.state.messages.length / 20 + 1 > 1) {
        var diff = newVal - oldVal
        this.$refs.scrollWrapper.scrollTop = diff
      }
    },
    // при изменениях маршрута запрашиваем данные снова
    'room_id': 'openRoom'
  },
  // Fetches posts when the component is created.
  methods: {
     nl2br (str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    ava(ava){
      if(!ava)
      {
        return this.no_ava
      }
      return ava
    },
      back() {
          this.$store.state.open_room_id=false
          this.openRoom()
      },
      
    openRoom () {
      this.loading = true
      this.page=1
      this.$store.state.messages = []
      this.infiniteId += 1;
      this.loading = false
    },
    convMessage(mes)
    {
      if(typeof mes === 'object')
      {
        return this.nl2br(mes.message)
      }
      return this.nl2br(JSON.parse(mes).message)
    },
    infiniteChatMesages ($state) {
      if (this.loading === false) {
        this.loading = true
        var req_room=false
        if(this.page==1)
        {
          req_room=true //Запросить данные о чате
        }
        this.$http.get(api, {
          params: {
            id: this.room_id,
            page: this.page,
            chatData: req_room
          }
        }).then(( response ) => {
          if(req_room===true && response.data.room)
          {
            var inf=response.data.room.data;
            if(!inf.avatar)
            {
              this.$set(this,'avatar',this.no_ava)
            }
            else
            {
              this.$set(this,'avatar',response.data.room.data.avatar)
            }
            this.$set(this,'status',response.data.room.data.status)
            this.$set(this,'name',response.data.room.data.name)
            this.$set(this,'online',response.data.room.data.online)
            this.$store.state.open_room=response.data.room
          }          
        if (response.data.data.length) {
          this.page += 1;

          this.$store.state.messages.unshift(...response.data.data);
          $state.loaded();
          this.loading = false
        } else {
          $state.complete();
        }

        })
      }
    }
  }
}
</script>
<style scoped>
.chat .chat-header {
  padding: 20px;
  border-bottom: 2px solid white;

}
.chat .chat-header img {
  float: left;
}
.chat .chat-header .chat-about {
  float: left;
  padding-left: 10px;
  margin-top: 6px;
}
.chat .chat-header .chat-with {
  font-weight: bold;
  font-size: 16px;
}
.chat .chat-header .chat-num-messages {
  color: #92959e;
}




.chat .chat-history {
  padding: 0px 0px 0px;
  border-bottom: 2px solid white;
  overflow-y: scroll;
  height: calc(90vh - 350px);

}
.people-list .search {
  padding: 20px 0px 0 20px;
}
.people-list .fa-search {
  position: relative;
  left: -25px;
}
.people-list ul {
  padding: 20px;
  height: 770px;
}
.people-list ul li {
  padding-bottom: 20px;
}
.people-list img {
  float: left;
  margin-right: 10px;
}
.people-list .about {
  float: left;
  margin-top: 8px;
}
.people-list .about {
  padding-left: 8px;
}
.people-list .status {
  color: #92959e;
}
.people-list input {
  border-radius: 3px;
  border: none;
  padding: 14px;
  color: white;
  background: #6a6c75;
  width: 60%;
  font-size: 14px;
}


.online {
  color: #86bb71;
}

.offline {
  color: #e46050;
}
.msg {
  width: 100%;
  height: auto;
  display: block;
  overflow: hidden;
}
.msg .bubble {
  float: left;
  max-width: 75%;
  width: auto;
  height: auto;
  display: block;
  background: #ebebeb;
  border-radius: 5px;
  position: relative;
  margin: 10px 0 3px 45px;
  box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.2);
}
.msg .bubble.alt {
  margin: 10px 45px 3px 0px;
  background: #dcf8c6;
  float: right;
}
.msg .bubble.follow {
  margin: 2px 0 3px 25px;
}
.msg .bubble.altfollow {
  margin: 2px 25px 3px 0px;
  background: #dcf8c6;
  float: right;
}
.msg .bubble .txt {
  padding: 8px 0 8px 0;
  width: 100%;
}
.msg .bubble .txt .name {
  font-weight: 600;
  font-size: 14px;
  display: inline-table;
  padding: 0 0 0 15px;
  margin: 0 0 4px 0;
  color: #3498db;
}
.msg .bubble .txt .name span {
  font-weight: normal;
  color: #b3b3b3;
  overflow: hidden;
}
.msg .bubble .txt .name.alt {
  color: #2ecc51;
}
.msg .bubble .txt .message {
  font-size: 14px;
  font-weight: 500;
  padding: 0 15px 0 15px;
  
  color: #2b2b2b;
  display: block;
}
.msg .bubble .txt .timestamp {
  font-size: 11px;
  margin: auto;
  padding: 0 15px 0 0;
  display: table;
  float: right;
  position: relative;
  text-transform: uppercase;
  color: #999;
}
.msg .bubble .bubble-arrow {
  position: absolute;
  float: left;
  left: -11px;
  top: 0px;
}
.msg .bubble .bubble-arrow.alt {
  bottom: 20px;
  left: auto;
  right: 4px;
  float: right;
}
.msg .bubble .bubble-arrow:after {
  content: "";
  position: absolute;
  border-top: 15px solid #ebebeb;
  border-left: 15px solid transparent;
  border-radius: 4px 0 0 0px;
  width: 0;
  height: 0;
}
.msg .bubble .bubble-avatar {
  position: absolute;
  float: left;
  left: -50px;
  top: 0px;
}
.msg .bubble .bubble-avatar.alt {
      bottom: 20px;
  left: auto;
  float: right;
  right: -50px;

}
.msg .bubble .avatar {
 display: block;
}
.msg .bubble .bubble-arrow.alt:after {
  border-top: 15px solid #dcf8c6;
  transform: scaleX(-1);
}

@media only screen and (max-width: 450px) {
  .container {
    width: 100%;
  }

  .timestamp {
    display: none;
    color: red;
  }
}
    </style>